import AccountSettings from "modules/account-settings"
import AccountPatSettings from "modules/account-pat-settings"
import { useIsPatFeatureEnabled } from "resources/account"

// Two sibling modules rather than one: each owns its own resource status, so a failing or
// reloading pat-settings can't blank the sessions card (or discard its unsaved edits), and
// vice versa. See modules/account-pat-settings/index.js.
export default function AccountSettingsPage() {
  const isPatFeatureEnabled = useIsPatFeatureEnabled()

  return <>
    <AccountSettings />
    {isPatFeatureEnabled && <AccountPatSettings />}
  </>
}
